<input
  type="text"
  placeholder="Calendar Search..."
  (keyup)="onKeyboardEvent($event)"
  (paste)="onClipboardEvent($event)"
  (cut)="onClipboardEvent($event)"
  [(ngModel)]="term"
/>

<div class="search" *ngIf="!searchResult || searchResult.matches <= 0">
  <svg width="17px" height="18px" viewBox="0 0 17 18" (click)="search($event)">
    <path
      d="M9.451,0.886 C5.299,0.886 1.922,4.207 1.922,8.289 C1.922,10.055 2.556,11.678 3.610,12.952 L-0.010,16.512 L1.411,17.909 L5.078,14.303 C6.312,15.174 7.820,15.692 9.451,15.692 C13.602,15.692 16.980,12.371 16.980,8.289 C16.980,4.207 13.602,0.886 9.451,0.886 ZM9.451,13.716 C6.408,13.716 3.932,11.281 3.932,8.289 C3.932,5.296 6.408,2.862 9.451,2.862 C12.494,2.862 14.971,5.296 14.971,8.289 C14.971,11.281 12.494,13.716 9.451,13.716 Z"
    />
  </svg>
</div>

<div class="results" *ngIf="searchResult && searchResult.matches > 0">
  <span>{{ CurrentHighlightIndex() }} of {{ searchResult.matches }}</span>
  <button id="previous-result" (click)="previousResult()">
    <svg width="10" height="6.2" viewBox="0 0 10 6.2">
      <polygon points="1.1 0 0 1.1 5 6.2 10 1.1 9 0 5 4 1.1 0" />
    </svg>
  </button>
  <button id="next-result" (click)="nextResult()">
    <svg width="10" height="6.2" viewBox="0 0 10 6.2">
      <polygon points="1.1 0 0 1.1 5 6.2 10 1.1 9 0 5 4 1.1 0" />
    </svg>
  </button>
  <button id="clear" (click)="clearSearch($event)">
    <svg width="10px" height="10px" viewBox="0 0 11 11">
      <path
        fill-rule="evenodd"
        d="M10.943,9.919 L9.888,10.974 L5.939,7.024 L1.990,10.974 L0.934,9.919 L4.884,5.969 L0.934,2.020 L1.990,0.965 L5.939,4.914 L9.888,0.965 L10.943,2.020 L6.994,5.969 L10.943,9.919 Z"
      />
    </svg>
  </button>
</div>
